export default __webpack_public_path__ + "static/media/icon_grrs_location.7100bfce.svg";